(ns core.front.components
  "Generic reagent components"
  (:require [app.front.util :refer [for-frag]]
            [clojure.set :as set]
            [core.front.carbon :as cc]
            [reagent.core :as r]))


(defn structured-list-keyed
  "Wraps Carbon StructuredListComponents."
  [opts header-row body-rows]
  {:pre [(get-in opts [:wrapper-opts :aria-label])]}
  (cc/structured-list-wrapper
    (or (:wrapper-opts opts) {})
    (cc/structured-list-head
      (or (:list-head-opts opts) {})
      (cc/structured-list-row
        {:head true
         :key  "head-row"}
        (for-frag [[idx head-cell] (map-indexed vector header-row)]
          (cc/structured-list-cell
            {:head true :key idx}
            head-cell))))
    (cc/structured-list-body
      (or (:list-body-opts opts) {})
      (for-frag [{:keys [key cells opts]} body-rows]
        (cc/structured-list-row
          (merge {:key key}
                 opts)
          (for-frag [[idx cell] (map-indexed vector cells)]
            (if (map? cell)
              (cc/structured-list-cell
                (merge {:key idx}
                       (:opts cell))
                (:content cell))
              (cc/structured-list-cell
                {:key idx}
                cell))))))))

(defn accordion-item
  "This accordion item does not render its contents into the DOM until it's opened, providing a significant
   performance boost for initial page rendering when the contents are complex."
  [key title contents]
  (r/with-let [open (r/atom false)]
    (cc/accordion-item {:title            title
                        :key              key
                        :open             @open
                        :on-heading-click #(swap! open not)}
                       (when @open
                         contents))))

(defn get-props [props]
  (->> props
       (map (fn [[k [_ v-js]]] [k v-js]))
       (into {})
       clj->js))

(defn set-props! [*props props]
  (-> *props
      (swap!
        (fn [old-props]
          (let [remove-keys (set/difference (-> old-props keys set) (-> props keys set))
                old-props   (if (seq remove-keys) (apply dissoc old-props remove-keys) old-props)]
            (->> props
                 (map (fn [[k v]]
                        (let [[v-old :as old] (get old-props k)]
                          [k
                           (if (= v v-old) old [v (clj->js v)])])))
                 (into {})))))
      get-props))

(defn react-wrapper
  "Memoized wrapper component for React components.

  Prevents unnecessary re-rendering by not interpreting every value
  of the properties map as changed when some of the properties change.

  Takes a React component and its properties map"
  [component props]
  (r/with-let [*props (->> props
                           (map (fn [[k v]]
                                  [k [v (clj->js v)]]))
                           (into {})
                           r/atom)]
    (r/create-element component (set-props! *props props))))
